import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import './PostDetailPage.css';

const API_URL = 'http://localhost:5000/api';

const PostDetailPage = ({ onLike }) => {
  const { id } = useParams();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPost = async () => {
      try {
        const response = await fetch(`${API_URL}/posts/${id}`);
        const data = await response.json();
        setPost(data);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching post:', error);
        setLoading(false);
      }
    };

    fetchPost();
  }, [id]);

  const handleLike = () => {
    if (post) {
      onLike(post._id);
      setPost({ ...post, likes: post.likes + 1 });
    }
  };

  if (loading) {
    return (
      <div className="post-detail-page">
        <div className="loading">Loading post...</div>
      </div>
    );
  }

  if (!post) {
    return (
      <div className="post-detail-page">
        <div className="error">Post not found</div>
      </div>
    );
  }

  return (
    <div className="post-detail-page">
      <div className="post-detail-container">
        {/* ADD TITLE SECTION */}
        <div className="post-title-section">
          <h1 className="post-title">{post.title}</h1>
        </div>
        
        <div className="post-media-large">
          {post.type === 'video' ? (
            <div className="video-container-large">
              <video 
                className="post-video-large"
                controls
                autoPlay
                preload="metadata"
                controlsList="nodownload"
              >
                <source src={post.imageUrl} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </div>
          ) : (
            <img 
              src={post.imageUrl} 
              alt={post.title}
              className="post-image-large"
            />
          )}
        </div>
        
        <div className="post-detail-content">
          <div className="post-description">
            {post.description}
          </div>
          
          <div className="post-detail-actions">
            <button 
              className="detail-like-count"
              onClick={handleLike}
            >
              🤍 {post.likes.toLocaleString()}
            </button>
            <button className="detail-share-btn">🔗 Share</button>
            <div className="post-date">
              📅 {new Date(post.date).toLocaleDateString()}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PostDetailPage;